import type { AppSidebarSection } from "@civala/shared-ui"
import {
  IconBuilding,
  IconChartPie,
  IconDiamond,
  IconFolder,
  IconShieldCheck,
  IconSparkles,
  IconWallet,
} from "@tabler/icons-react"

export const NAV_SECTIONS: ReadonlyArray<AppSidebarSection> = [
  {
    id: "six-alphas",
    label: "Six Alphas",
    icon: IconDiamond,
    path: "/six-alphas",
  },
  {
    id: "portfolio",
    label: "Portfolio",
    icon: IconChartPie,
    path: "/",
  },
  {
    id: "companies",
    label: "Companies",
    icon: IconBuilding,
    path: "/companies",
  },
  {
    id: "investments",
    label: "Federation Portfolio",
    icon: IconWallet,
    path: "/investments",
  },
  {
    id: "capital-calls",
    label: "Capital Calls",
    icon: IconWallet,
    path: "/capital-calls",
  },
  {
    id: "risk-feed",
    label: "Risk Feed",
    icon: IconSparkles,
    path: "/risk-feed",
  },
  {
    id: "qsbs",
    label: "QSBS Tracker",
    icon: IconShieldCheck,
    path: "/qsbs",
  },
  {
    id: "hub",
    label: "Corporate Hub",
    icon: IconFolder,
    path: "/hub",
    children: [
      { id: "documents", label: "Documents", path: "/hub/documents" },
      { id: "ic-meetings", label: "IC Meetings", path: "/hub/ic-meetings" },
      { id: "ic-nav-mark", label: "  — NAV Mark", path: "/hub/ic-meetings/nav-mark" },
      { id: "ic-template", label: "  — Template", path: "/hub/ic-meetings/template" },
      { id: "ic-artifact", label: "  — Artifact", path: "/hub/ic-meetings/artifact" },
      { id: "communications", label: "Board Inbox", path: "/hub/communications" },
      { id: "comm-thread", label: "  — Thread", path: "/hub/communications/thread" },
      { id: "comm-session", label: "  — Session", path: "/hub/communications/session" },
      { id: "comm-synthesis", label: "  — Synthesis", path: "/hub/communications/synthesis" },
      { id: "tax-documents", label: "Tax Documents", path: "/hub/tax-documents" },
    ],
  },
]
